// @ts-strict-ignore
import {
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  ButtonVariant,
  DropdownMenu,
  IconName,
  Text,
} from '@usealloy/component-library';

import { NotificationsContext } from '~/dashboard/context';

import { filterNotifications } from '../helpers';
import {
  DropdownHeaderWrapper,
  NotificationCountBadge,
  NotificationMenuButton,
  dropdownMenuStyles,
} from './notificationStyles';
import { Notification } from './Notification';

interface NotificationDropdownProps {
  inNotificationView: boolean;
}

export const NotificationDropdown = ({ inNotificationView }: NotificationDropdownProps) => {
  const navigate = useNavigate();
  const { notifications } = useContext(NotificationsContext);

  const [
    filteredNotifications,
    setFilteredNotifications,
  ] = useState(filterNotifications(notifications));

  // refresh the state whenever the user context updates
  useEffect(() => {
    setFilteredNotifications(filterNotifications(notifications));
  }, [notifications]);

  const notificationCount = useMemo(() => (
    filteredNotifications?.filter(({ viewed }) => viewed === false).length || 0
  ), [filteredNotifications]);

  const handleNavigation = notification => {
    if (notification.url) {
      if (notification.url.startsWith('http')) {
        window.open(notification.url, '_blank');
      } else {
        navigate(notification.url);
      }
    } else {
      navigate(`/v3/dashboard/notifications#${notification.notificationId}`);
    }
  };

  return (
    <DropdownMenu
      align="end"
      style={dropdownMenuStyles}
      trigger={(
        <NotificationMenuButton
          icon={IconName.Bell}
          inNotificationView={inNotificationView}
          variant={ButtonVariant.tertiary}
        >
          {!inNotificationView && notificationCount > 0 && (
            <NotificationCountBadge status="danger">{notificationCount}</NotificationCountBadge>
          )}
        </NotificationMenuButton>
      )}
    >
      <Box direction="column">
        <DropdownHeaderWrapper direction="row" justifyContent="space-between">
          <Text size={4}>Notifications</Text>
          <Button onClick={() => { navigate('/v3/dashboard/notifications'); }}>View All</Button>
        </DropdownHeaderWrapper>
        <Box direction="column" gap={2}>
          {filteredNotifications?.length > 0
            ? filteredNotifications.map(notification => (
              <Notification
                handleNavigation={() => { handleNavigation(notification); }}
                key={notification.notificationId}
                notification={notification}
                truncateContent
              />
            )) : (
              <Box direction="column" alignItems="center" justifyContent="center" gap={2} style={{ height: '320px' }}>
                <Text lineHeight={4} size={2} weight={700}>No New Notifications</Text>
                <Text lineHeight={4} size={2} style={{ color: 'var(--cl-text-secondary)' }}>
                  You&apos;re all caught up, no new notifications are available
                </Text>
              </Box>
            )}
        </Box>
      </Box>
    </DropdownMenu>
  );
};
